import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCopierList} from '../../../apis/copier/copier'
import {ICopierRow} from '../../../apis/copier/copiers'

const PAGE_SIZE = 100

// 카피어 디테일(admin/copy/copier/:id)은 bot / bot_score를 비워 보내서
// 초기 잔고·입출금·수익률을 알 수 없다. 목록(admin/copy/copiers)은 이 값을 채워 주므로
// 같은 유저의 봇 목록에서 해당 봇 행을 찾아 보완한다.
// 기본 필터가 삭제된 봇을 제외하므로 삭제된 봇이면 filter_status='deleted'로 조회한다.
const useQueryCopierBotRow = (userId?: string, botId?: string, isDeleted: boolean = false) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getCopierBotRow(userId, botId, isDeleted),
        queryFn: async (): Promise<ICopierRow | undefined> => {
            const {data} = await getCopierList(PAGE_SIZE, 1, userId, isDeleted ? 'deleted' : '')
            return data?.find(item => item?.id === botId)
        },
        enabled: Boolean(userId) && Boolean(botId),
        refetchOnWindowFocus: false,
    })

    return {data, refetch, isLoading}
}

export default useQueryCopierBotRow
